export * from './routes';
export * from './shopify';
export * from './dates';
export * from './time';
export * from './emails';
export * from './advertisementData';
export * from './attribution';
export * from './classes';
export * from './data-testid';

export const notAvailable = 'n/a';
export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const HOUR_IN_SECONDS = 3600;
export const TEN_MINUTES_IN_MS = 10 * 60 * SECOND;
export const YEAR_IN_DAYS = 365;
export const YEAR_IN_SECONDS = 24 * HOUR_IN_SECONDS * YEAR_IN_DAYS;
